// Permission status constants
export const PERMISSION_STATUS = {
  GRANTED: "granted" as const,
  DENIED: "denied" as const,
  DEFAULT: "default" as const,
  BLOCKED: "blocked" as const,
  UNSUPPORTED: "unsupported" as const,
  UNKNOWN: "unknown" as const,
  PENDING: "pending" as const,
};

// LocalStorage keys for push notification state
export const STORAGE_KEYS = {
  PUSH_GRANTED: "push_permission_granted",
  PUSH_REJECTED_AT: "push_rejected_at",
  PUSH_PERMANENTLY_DISMISSED: "push_permanently_dismissed",
  LAST_PERMISSION_CHECK: "last_permission_check",
} as const;

// Time constants for push notification behavior
export const POPUP_DELAY_MS = 2500; // 2.5 seconds after login
export const REJECTION_COOLDOWN_MS = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds
export const PERMISSION_CHECK_INTERVAL = 5000; // 5 seconds

export const NOTIFICATION = {
  PERMISSION_INITIAL: {
    PUSH_PERMISSION_TITLE: "Stay Updated",
    PUSH_PERMISSION_DESCRIPTION: `<p>Enable notifications to receive important updates and offers directly on your device.</p>
      <ul><li>Get timely tracking reminders</li>
        <li>Receive practical tips for your journey </li></ul>`,
    PUSH_PERMISSION_ALLOW_BUTTON_TEXT: "Allow",
    PUSH_PERMISSION_REJECT_BUTTON_TEXT: "Maybe Later",
  },
  BLOCKED_MESSAGE: {
    UNSUPPORTED: {
      TITLE: "Notifications Are Not Supported",
      DESCRIPTION:
        "Notifications are not supported in your current browser. To receive push notifications, please use a modern browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Safari.",
    },
    BLOCKED: {
      TITLE: "Notifications Are Blocked",
      DESCRIPTION:
        "You've previously blocked notifications for this site. To receive updates, you'll need to enable them in your browser settings.<blockquote>Note: If you're browsing in incognito or private mode, notifications are not available.</blockquote>",
      SHOW_INSTRUCTIONS_TEXT: "Show me how to enable notifications",
      INSTRUCTIONS_NOTE:
        '💡 After enabling notifications, click "Check Again" below.',
      RETRY_BUTTON_TEXT: "Check Again",
      RETRY_BUTTON_TEXT_CHECKING: "Checking...",
    },
    DISMISS_BUTTON_TEXT: "Don't Show This Again",
  },
  ENABLE_INSTRUCTIONS: {
    CHROME: {
      name: "Chrome",
      android: [
        "Tap the menu icon (⋮) in the top-right corner",
        'Select "Settings"',
        'Tap "Site settings" or "Notifications"',
        "Find this site in the list",
        'Toggle "Notifications" to "Allow"',
        "Refresh this page",
      ],
      ios: [
        "Open Settings app on your iPhone",
        "Scroll down and tap on the app name",
        'Tap "Notifications"',
        'Enable "Allow Notifications"',
        "Return to the app and refresh",
      ],
      web: [
        "Click the lock icon (🔒) or site settings icon in the address bar",
        'Find "Notifications" in the permissions list',
        'Change from "Block" to "Allow"',
        "Refresh this page",
      ],
    },
    SAFARI: {
      name: "Safari",
      ios: [
        "Open Settings app on your iPhone",
        "Scroll down and tap on the app name",
        'Tap "Notifications"',
        'Enable "Allow Notifications"',
        "Return to the app and refresh",
      ],
      web: [
        "Open Safari menu → Preferences",
        'Click on "Websites" tab',
        'Select "Notifications" from the sidebar',
        'Find this website and change to "Allow"',
        "Refresh this page",
      ],
    },
    FIREFOX: {
      name: "Firefox",
      android: [
        "Tap the menu icon (⋮) in the top-right corner",
        'Select "Settings"',
        'Tap "Site permissions"',
        'Tap "Notifications"',
        'Find this site and change to "Allow"',
        "Refresh this page",
      ],
      web: [
        "Click the lock icon (🔒) in the address bar",
        'Click "More information" or the arrow (>)',
        'Go to "Permissions" tab',
        'Find "Notifications" and uncheck "Use Default"',
        'Select "Allow"',
        "Refresh this page",
      ],
    },
    EDGE: {
      name: "Edge",
      web: [
        "Click the lock icon (🔒) in the address bar",
        'Find "Notifications" in the permissions',
        'Change from "Block" to "Allow"',
        "Refresh this page",
      ],
    },
    GENERIC: {
      name: "your browser",
      web: [
        "Click the lock or site settings icon in your address bar",
        'Find "Notifications" in the permissions list',
        'Change the setting to "Allow"',
        "Refresh this page",
      ],
    },
  },
};

export const PUSH_PERMISSION_MODAL_ID = "push-permission-modal";
export const PUSH_BLOCKED_MODAL_ID = "push-blocked-modal";
